import type { ReactNode, Ref } from 'react';
import type { DocumentsDiffProps } from './DocumentDiff.types';

import { forwardRef } from 'react';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';

import './_documents-diff.scss';

export const DocumentsDiff = forwardRef(
  ({ diff, className }: DocumentsDiffProps, ref: Ref<HTMLDivElement>) => {
    if (!diff) {
      return null;
    }

    const parsedDiff = ReactHtmlParser(diff) as ReactNode;

    return (
      <div className={classnames('document-diff__container', className)} ref={ref}>
        <div className="document-diff__legend-container">
          <span className="document-diff__legend-entry">
            <div className="document-diff__color-block--additions" />
            <span>Additions</span>
          </span>
          <span className="document-diff__legend-entry">
            <div className="document-diff__color-block--deletions" />
            <span>Deletions</span>
          </span>
        </div>
        <div className="document-diff__results">{parsedDiff}</div>
      </div>
    );
  }
);
